<script>
import { mapGetters } from 'vuex';
import Dashboard from '@/home/components/Dashboard.vue';

export default {
  components: {
    Dashboard,
  },

  computed: {
    ...mapGetters(['appName']),
    ...mapGetters('auth', ['userHasNoRoles']),
  },
}
</script>

<template>
  <b-card>

    <h4 class="text-center">You clicked cancel</h4>

    <p class="text-center">Please click on the menu above to choose where you want to go.</p>

  </b-card>
</template>



// WEBPACK FOOTER //
// src/home/views/FormCancelledView.vue